export default function PHP_var() {
  return (
    <div>
      <h1>PHP_var</h1>
    </div>
  );
}
